export const brandConfigObjectMap = new Map();
brandConfigObjectMap.set('vc-za-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    googleTag: 'G-JGRR0HQX82',
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('mtn-cg-fr', {
    revenuePartnerId: 15,
    isRandomDrawAwarded: false,
    tabTitle: 'Football Manager',
    userAccessId: 2,
    isAwardingMinutes: true,
    productId: 11,
    showPrizes: false
});
brandConfigObjectMap.set('mtn-ci-fr', {
    revenuePartnerId: 29,
    isRandomDrawAwarded: true,
    tabTitle: 'Football Manager',
    userAccessId: 3,
    googleTag: 'G-BJCTGMN15R',
    productId: 13,
    showPrizes: true
});
brandConfigObjectMap.set('mtn-cmr-fr', {
    revenuePartnerId: 31,
    isRandomDrawAwarded: true,
    tabTitle: 'Football Manager',
    userAccessId: 4,
    googleTag: 'G-9VN79PGBLT',
    productId: 14,
    showPrizes: true
});
brandConfigObjectMap.set('mtn-nga-en', {
    revenuePartnerId: 35,
    isRandomDrawAwarded: true,
    tabTitle: 'Fantasy Games',
    userAccessId: 5,
    googleTag: 'G-NVNS46BPT8',
    productId: 15,
    showPrizes: false
});
brandConfigObjectMap.set('ethiotel-et-en', {
    revenuePartnerId: 37,
    isRandomDrawAwarded: true,
    tabTitle: 'Fantasy Sports',
    userAccessId: 6,
    googleTag: 'G-5FDQ5GXM95',
    productId: 16,
    showPrizes: true
});
brandConfigObjectMap.set('ethiotel-et-amh', {
    revenuePartnerId: 37,
    isRandomDrawAwarded: true,
    tabTitle: 'Fantasy Sports',
    userAccessId: 6,
    googleTag: 'G-5FDQ5GXM95',
    productId: 16,
    showPrizes: true
});
brandConfigObjectMap.set('demo-et-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('demo-um-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    productId: 8,
    showPrizes: false
});
brandConfigObjectMap.set('demo-arabic', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    isRTL: true,
    language: 'ar',
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('ais-tai-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Championship Manager',
    userAccessId: 1,
    productId: 8,
    showPrizes: false
});
brandConfigObjectMap.set('ais-tai-tha', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Championship Manager',
    userAccessId: 1,
    productId: 34,
    showPrizes: true
});
brandConfigObjectMap.set('dtac-tai-tha', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('dtac-tai-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('mtn-zam-en', {
    revenuePartnerId: 38,
    isRandomDrawAwarded: true,
    tabTitle: 'Fantasy Football',
    userAccessId: 7,
    googleTag: 'G-9TZ1RTRHTY',
    productId: 17,
    showPrizes: true
});
brandConfigObjectMap.set('saudi-uae-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('air-nga-en', {
    revenuePartnerId: 45,
    isRandomDrawAwarded: true,
    tabTitle: 'Fantasy Games',
    userAccessId: 8,
    googleTag: 'G-NVNS46BPT8',
    productId: 22,
    showPrizes: true
});
brandConfigObjectMap.set('saf-ke-en', {
    revenuePartnerId: undefined,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Sports',
    userAccessId: undefined,
    productId: 40,
    serviceId: 127,
    showPrizes: false
});
brandConfigObjectMap.set('mtn-gha-en', {
    revenuePartnerId: 46,
    isRandomDrawAwarded: true,
    tabTitle: 'Fantasy Football',
    userAccessId: 12,
    googleTag: 'G-NVNS46BPT8',
    productId: 23,
    showPrizes: true
});
brandConfigObjectMap.set('demo-romanian', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    userAccessId: 1,
    productId: 8,
    showPrizes: true
});
brandConfigObjectMap.set('tlk-za-en', {
    revenuePartnerId: 1,
    isRandomDrawAwarded: false,
    tabTitle: 'Fantasy Football',
    notUpstreamService: true,
    userAccessId: 13,
    productId: 53,
    showPrizes: true
});
